import { t } from '@lingui/core/macro';
import { z } from 'zod';

// Regras dos schemas yup do legado (pages/Login/*Schema.ts), mensagens literais.
// eslint-disable-next-line no-useless-escape -- regex copiada 1:1 do legado
const PASSWORD_POLICY = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;

/** As mesmas regras da `PASSWORD_POLICY`, uma a uma, para a lista ao vivo do formulário (só apresentação). */
export function passwordChecks(value: string) {
  return {
    length: value.length >= 8,
    upper: /[A-Z]/.test(value),
    lower: /[a-z]/.test(value),
    number: /[0-9]/.test(value),
    // eslint-disable-next-line no-useless-escape -- mesma classe da regex do legado
    special: /[!@#\$%\^&\*]/.test(value),
  } as const;
}

export type PasswordCheck = keyof ReturnType<typeof passwordChecks>;

const newPassword = () =>
  z
    .string()
    .min(1, t`Senha: Precisa ser preenchido.`)
    .regex(PASSWORD_POLICY, t`A senha deve conter pelo menos 8 caracteres, incluindo maiúsculas, minúsculas, caracteres especiais e número`)
    .min(8, t`A senha é muito curta - deve ter no mínimo 8 caracteres.`);

const confirmation = () => z.string().min(1, t`Confirmar senha: Precisa ser preenchido.`);

const mismatch = () => ({ message: t`A senha e a confirmação de senha não conferem`, path: ['passwordConfirmation'] });

const code6 = () =>
  z
    .string()
    .min(1, t`Campo obrigatório.`)
    .length(6, t`Deve possuir 6 dígitos`);

export const loginSchema = () =>
  z.object({
    email: z.string().min(1, t`Campo obrigatório.`).pipe(z.email(t`email inválido`)),
    password: z.string().min(1, t`Senha: Precisa ser preenchido.`),
  });

export const mfaSchema = () => z.object({ code: code6() });

export const newPasswordSchema = () =>
  z
    .object({ password: newPassword(), passwordConfirmation: confirmation() })
    .refine((v) => v.password === v.passwordConfirmation, mismatch());

export const changePasswordSchema = () =>
  z
    .object({ oldPassword: z.string().min(1, t`Senha: Precisa ser preenchido.`), password: newPassword(), passwordConfirmation: confirmation() })
    .refine((v) => v.password === v.passwordConfirmation, mismatch());

export const recoverEmailSchema = () =>
  z.object({ email: z.string().min(1, t`Email: Precisa ser preenchido.`).pipe(z.email(t`Email inválido.`)) });

export const recoverConfirmSchema = () =>
  z
    .object({ code: z.string().min(1, t`Código: Precisa ser preenchido.`), newPassword: newPassword(), passwordConfirmation: confirmation() })
    .refine((v) => v.newPassword === v.passwordConfirmation, mismatch());

export const confirmEmailSchema = () => z.object({ code: z.string().min(1, t`Código precisa ser preenchido.`) });
